<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title>Customers</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()">
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
            class="pl-4 pr-4"
          >
            <v-form ref="form" v-model="frmValid">
              <v-text-field
                v-model="txtName"
                label="Name"
              ></v-text-field>
              <v-text-field
                v-model="txtEmail"
                label="Email"
              ></v-text-field>
              <v-select
                v-model="cboType"
                :items="types"
                label="Type"
              ></v-select>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="caption"
                item-value="value"
                label="Sorting"
              ></v-select>
              <v-btn
                :disabled="!frmValid"
                @click="items=[]; getCustomers(txtName, txtEmail, cboType, cboSort); rightDrawer=false;"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-list two-line fill-height>
        <template
          v-for="(item, index) in items"
        >
          <v-list-tile
            :key="item.userId"
            avatar
            ripple
            :class="(index % 2 === 0 ? 'row1' : 'row2')"
          >
            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-btn outline class="mr-4" v-if="isSuperUser" @click="loginAsUser(item.userId)">
                  Login
                </v-btn>
              </v-list-tile-action-text>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }} {{ item.firstName }} {{ item.lastName }}
                <span v-if="item.type === 'wholesale'" class="red white--text caption pa-2 ml-2">{{ item.type | allCaps }} (until {{ item.wholesalePeriodEndDateTime | formatDate('D MMM YYYY', profile.gmtTimezone) }})</span>
                <span v-if="item.isChargeback === '1'" class="body-1 ml-3 font-weight-bold red--text">CHARGEBACK</span>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{ item.loginEmail }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <div v-if="item.type === 'wholesale'">
                  Total purchase this period:
                  <router-link :to="'/customer/' + item.userId + '/orders'" class="white--text">
                    {{ def.currency.sign }}{{ formatPrice(item.wholesalePeriodTotalPurchase) }}
                  </router-link>
                  <span>/ {{ def.currency.sign }}{{ formatPrice(item.wholesalePeriodTargetPurchase) }}</span>
                </div>
                <div v-else>
                  Total purchases:
                  <router-link :to="'/customer/' + item.userId + '/orders'" class="white--text">
                    {{ def.currency.sign }}{{ formatPrice(item.totalPurchase) }}
                  </router-link>
                </div>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>
                Last order: {{ item.lastOrderDateTimeDisplay }}
              </v-list-tile-action-text>
              <v-btn outline small class="pl-2 pr-2" v-if="isAccessTransaction" :to="'/customer/' + item.userId + '/transactions'">
                Balance: {{ def.currency.sign }}{{ formatPrice(item.cacheBalanceAmount) }}
              </v-btn>
            </v-list-tile-action>

            <v-btn icon class="ml-3" color="primary" :to="'/customer/' + item.userId">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No customer yet
            </div>
          </v-flex>
        </template>
      </v-list>
      <!--<v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          class="mr-5"
          to="/customer"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>-->
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'
import moment from 'moment'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      rightDrawer: false,
      loading: false,
      frmValid: true,
      txtName: '',
      txtEmail: '',
      cboType: '',
      types: ['retail', 'wholesale'],
      cboSort: '',
      sorts: [
        {
          caption: 'Latest',
          value: 'createdDateTime:desc'
        },
        {
          caption: 'Name',
          value: 'firstName:asc'
        },
        {
          caption: 'Balance (plus to minus)',
          value: 'cacheBalanceAmount:desc'
        },
        {
          caption: 'Balance (minus to plus)',
          value: 'cacheBalanceAmount:asc'
        }
      ],
      isAccessTransaction: false,
      isSuperUser: false,
      isLoadingItems: false,
      items: [],
      listLimit: 15,
      listOffset: 0,
      listTotal: 0
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getCustomers()

    if (typeof this.profile.permissions !== 'undefined') {
      for (var i in this.profile.permissions) {
        if (this.profile.permissions[i].permissionId === 'PEM-TRANSACTION' && this.profile.permissions[i].isRead === '1') {
          this.isAccessTransaction = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-ADMIN' && this.profile.permissions[i].isCreate === '1') {
          this.isSuperUser = true
        }
      }
    }
  },

  created () {
    window.addEventListener('scroll', this.detectBottomOfWindow)
  },

  destroyed () {
    window.removeEventListener('scroll', this.detectBottomOfWindow)
  },

  methods: {
    refreshList: function () {
      this.items = []
      var _this = this
      return new Promise(function (resolve, reject) {
        var promise = _this.getCustomers(_this.txtName, _this.txtEmail, _this.cboType, _this.cboSort, 0)
        promise.then(function () {
          resolve()
        })
      })
    },
    detectBottomOfWindow: function (event) {
      // console.log(document.documentElement.scrollTop + window.innerHeight) - 48;
      // console.log(document.documentElement.offsetHeight);
      let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= (document.documentElement.offsetHeight - 5)
      if (bottomOfWindow) {
        if (this.listTotal > this.items.length) {
          this.getCustomers(this.txtName, this.txtEmail, this.cboType, this.cboSort, this.items.length)
        }
      }
    },
    getCustomers: function (name = '', email = '', type = '', sort = '', offset = 0) {
      var _this = this
      if (_this.isLoadingItems === false) {
        _this.isLoadingItems = true
        var promise = new Promise(function (resolve, reject) {
          _this.loading = true
          axios.get(process.env.VUE_APP_API_ROOT + '/v1/users?type=' + type + '&name=' + name + '&login_email=' + email + '&sort=' + sort + '&limit=' + _this.listLimit + '&offset=' + offset)
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                for (var c = 0; c < resp.data.data.length; ++c) {
                  if (resp.data.data[c].lastOrderDateTime) {
                    resp.data.data[c].lastOrderDateTimeDisplay = moment(resp.data.data[c].lastOrderDateTime, _this.iso8601Format()).fromNow()
                  } else {
                    resp.data.data[c].lastOrderDateTimeDisplay = 'No order yet'
                  }
                }
                _this.items = _this.items.concat(resp.data.data)
                _this.listLimit = resp.data.limit
                _this.listOffset = resp.data.offset
                _this.listTotal = resp.data.total
              } else {
                console.log('unable to load customers: ' + resp.data.message)
              }
              _this.isLoadingItems = false
              resolve()
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                  reject(error.response.status)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                  reject(error.response.status)
                }
                _this.isLoadingItems = false
                _this.loading = false
              }
            })
        })
        return promise
      }
    },
    clearFilter () {
      this.$refs.form.reset()
      this.items = []
      this.getCustomers(this.txtName, this.txtEmail, this.cboSort)
      this.rightDrawer = false
    },
    loginAsUser: function (userId) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + userId + '/login/user')
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              window.open(_this.def.marketplaceDomain + '/me/login/token/' + resp.data.data.token)
            } else {
              window.alert('unable to login as user: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              _this.loading = false
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
            }
          })
      })
      return promise
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
